import "./Futon.css"

export default function Futon() {
  return (
    <div className="futon">
      <nav>
        <div className="floating-cta-button-blog">
          <a href="/articles#">Our Blog</a>
        </div>
      </nav>
    </div>
  )
}
